import { useEffect, useState } from "react";

/** Synchronous on first paint (client-only SPA), then keeps in sync with the media query. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const list = window.matchMedia(query);
    const update = () => setMatches(list.matches);
    update();
    list.addEventListener("change", update);
    return () => list.removeEventListener("change", update);
  }, [query]);

  return matches;
}

/** Tailwind `lg` breakpoint: desktop shows the sidebar, mobile shows the tab bar. */
export function useIsDesktop(): boolean {
  return useMediaQuery("(min-width: 1024px)");
}
